
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4ff2"];
var parcelRegister = parcelRequire.register;
parcelRegister("87OSm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $275a135a68423bd3$export$2e2bcd8739ae039; });

var $iGQ0X = parcelRequire("iGQ0X");

var $9kFno = parcelRequire("9kFno");

var $1unwV = parcelRequire("1unwV");

var $b6PLb = parcelRequire("b6PLb");
const $275a135a68423bd3$var$DEFAULT_HEADER_TEXT = "An official website of the United States government";
const $275a135a68423bd3$var$DEFAULT_HEADER_ACTION_TEXT = "Here's how you know";
const $275a135a68423bd3$var$DEFAULT_FLAG_SRC = "/img/us_flag_small.png";
const $275a135a68423bd3$var$DEFAULT_FLAG_ALT = "U.S. flag";
const $275a135a68423bd3$var$DEFAULT_GUIDANCE = {
    left: {
        title: "Official websites use .gov",
        text: "A .gov website belongs to an official government organization in the United States.",
        iconAlt: "Dot gov icon",
        icon: "/img/icon-dot-gov.svg"
    },
    right: {
        title: "Secure .gov websites use HTTPS",
        text: `
        A <strong>lock</strong> or <strong>https://</strong> means you've safely
        connected to the .gov website. Share sensitive information only on
        official, secure websites.
      `,
        iconAlt: "HTTPS icon",
        icon: "/img/icon-https.svg"
    }
};
const $275a135a68423bd3$var$GuidanceBlock = ({ content: content, className: className })=>/*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $1unwV.USWDSBannerGuidance), {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSBannerIcon), {
                src: content.icon,
                alt: content.iconAlt ?? ""
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSMediaBlockBody), {
                children: /*#__PURE__*/ (0, $iGQ0X.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $iGQ0X.jsx)("strong", {
                            children: content.title
                        }),
                        /*#__PURE__*/ (0, $iGQ0X.jsx)("br", {}),
                        /*#__PURE__*/ (0, $iGQ0X.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: content.text ?? ""
                            }
                        })
                    ]
                })
            })
        ]
    });
function $275a135a68423bd3$export$2e2bcd8739ae039({ headerText: headerText, headerActionText: headerActionText, ariaLabel: ariaLabel, flagImgAlt: flagImgAlt = "", flagImgSrc: flagImgSrc, leftGuidance: leftGuidance, rightGuidance: rightGuidance, className: className = "", defaultIsOpen: defaultIsOpen = false, contentId: contentId = "gov-banner-content" }) {
    const [isOpen, setIsOpen] = (0, $9kFno.useState)(defaultIsOpen);
    const leftContent = {
        ...$275a135a68423bd3$var$DEFAULT_GUIDANCE.left,
        ...leftGuidance
    };
    const uswdsHeaderActive = (0, $b6PLb.checkEnvFlag)(undefined);
    const rightContent = {
        ...$275a135a68423bd3$var$DEFAULT_GUIDANCE.right,
        ...rightGuidance
    };
    return /*#__PURE__*/ (0, $iGQ0X.jsxs)((0, $1unwV.USWDSBanner), {
        "aria-label": ariaLabel ?? $275a135a68423bd3$var$DEFAULT_HEADER_TEXT,
        className: `${className} ${!uswdsHeaderActive && "banner--left-aligned"}`,
        children: [
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSBannerHeader), {
                isOpen: isOpen,
                flagImg: /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSBannerFlag), {
                    src: flagImgSrc ?? $275a135a68423bd3$var$DEFAULT_FLAG_SRC,
                    alt: flagImgAlt ?? $275a135a68423bd3$var$DEFAULT_FLAG_ALT
                }),
                headerText: headerText ?? $275a135a68423bd3$var$DEFAULT_HEADER_TEXT,
                headerActionText: headerActionText ?? $275a135a68423bd3$var$DEFAULT_HEADER_ACTION_TEXT,
                children: /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSBannerButton), {
                    isOpen: isOpen,
                    onClick: ()=>setIsOpen((prev)=>!prev),
                    "aria-controls": contentId,
                    children: headerActionText ?? $275a135a68423bd3$var$DEFAULT_HEADER_ACTION_TEXT
                })
            }),
            /*#__PURE__*/ (0, $iGQ0X.jsx)((0, $1unwV.USWDSBannerContent), {
                id: contentId,
                isOpen: isOpen,
                children: /*#__PURE__*/ (0, $iGQ0X.jsxs)("div", {
                    className: "grid-row grid-gap-6",
                    children: [
                        /*#__PURE__*/ (0, $iGQ0X.jsx)($275a135a68423bd3$var$GuidanceBlock, {
                            content: leftContent,
                            className: "tablet:grid-col-6"
                        }),
                        /*#__PURE__*/ (0, $iGQ0X.jsx)($275a135a68423bd3$var$GuidanceBlock, {
                            content: rightContent,
                            className: "tablet:grid-col-6"
                        })
                    ]
                })
            })
        ]
    });
}

});


//# sourceMappingURL=banner.5e747ff2.js.map
